import React, { Fragment } from "react"
import classnames from "classnames"

import styles from "./styles.css"

const NoScheduleOnlineInterfaceSkeleton = () => {
  const mainSectionClasses = classnames(
    styles.mainSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )
  const titleClasses = classnames(styles.skeletonText, styles.skeleton)
  const descriptionClasses = classnames(
    styles.skeletonDescription,
    styles.skeleton
  )
  const buttonClasses = classnames(styles.skeletonButton, styles.skeleton)

  return (
    <Fragment>
      <div className={mainSectionClasses}>
        <div className={titleClasses}></div>
        <div className={descriptionClasses}></div>
        <div className={descriptionClasses}></div>
        <div className={buttonClasses}></div>
      </div>
    </Fragment>
  )
}
export default NoScheduleOnlineInterfaceSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/NoScheduleOnlineInterfaceSkeleton/index.js